/*
 * @Author: zhangliang
 * @Date: 2020-01-30 19:35:33
 * @LastEditTime: 2020-03-20 12:55:20
 * @LastEditors: zhangliang
 * @Description: 
 * @FilePath: \asset_app\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/storeList',
    name: 'storeList',
    meta: {
      title: '供应商入库报表'
    },
    component: () => import('../views/StoreList.vue') // 供应商入库报表
  },
  {
    path: '/analyse',
    name: 'analyse',
    meta: {
      title: '分析报表'
    },
    component: () => import('../views/Analyse.vue') // 分析报表
  },
  {
    path: '/consumableAnalyse',
    name: 'consumableAnalyse',
    meta: {
      title: '分析报表'
    },
    component: () => import('../views/ConsumableAnalyse.vue') // 耗材分析报表
  },
  {
    path: '/notice',
    name: 'notice',
    meta: {
      title: '消息详情'
    },
    component: () => import('../views/Notice.vue') // 消息详情
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      title: '精臣用户许可协议'
    },
    component: () => import('../views/Agreement.vue') // 精臣用户许可协议
  },
  {
    path: '/secret',
    name: 'secret',
    meta: {
      title: '保密协议'
    },
    component: () => import('../views/Secret.vue') // 保密协议
  },
  {
    path: '/third_sdk',
    name: 'third_sdk',
    meta: {
      title: '第三方SDK目录'
    },
    component: () => import('../views/thirdSDK.vue') 
  },
  {
    path: '/jxc_secret',
    name: 'jxc_secret',
    meta: {
      title: '保密协议'
    },
    component: () => import('../views/JXCSecret.vue') // 进销存保密协议
  },
  {
    path: '/jxc_third_sdk',
    name: 'jxc_third_sdk',
    meta: {
      title: '进销存第三方SDK目录'
    },
    component: () => import('../views/JXCThirdSDK.vue')
  },
]

export const dynamicRouter = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '首页'
    },
    component: () => import('../views/Home.vue') // 首页
  },
  {
    path: '/demo',
    name: 'demo',
    meta: {
      title: 'demo页'
    },
    component: () => import('../views/Demo.vue') // demo页
  }
]


const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

if (process.env.NODE_ENV !== 'production') {
  router.addRoutes(dynamicRouter)
}

export default router